import { RecentFeaturedListing, Testimonial } from './sell-your-car.type';

export const getRecentFeaturedListings = async () => {
  return await apiClient().get<RecentFeaturedListing[]>('/listing/recent-featured-listing');
};

const showcaseFeatures = [
  'Tell your car’s full story—enjoy generous space for descriptions, up to 100 photos, and video uploads.',
  'Edit your listing any time—keep your details fresh and up-to-date whenever you want.',
  'Track your success—monitor real-time ad views right from your personal seller dashboard.',
  `Tap into unmatched exposure—reach buyers nationwide through search engines, 
  social media, and our vibrant community.`,
  'Post first, perfect later—list your car instantly and add photos or details at your own pace.',
  'Get direct connections—receive buyer inquiries straight to your inbox for a fast, smooth sale.',
];

const testimonials: Testimonial[] = [
  {
    name: 'Kelly Reyes',
    text: `Highly recommend, was about to share my excitement about 
    the progress we've made at ClovisClassics. Keep up!`,
    avatar: '/images/dealer-partner/seller-avatar1.png',
    rating: 5,
  },
  {
    name: 'Janiyah Matthews',
    text: `Highly recommend, was about to share my excitement about 
    the progress we've made at ClovisClassics. Keep up!`,
    rating: 5,
    avatar: '/images/dealer-partner/seller-avatar2.png',
  },
  {
    name: 'Elliot Watson',
    text: `Highly recommend, was about to share my excitement about 
    the progress we've made at ClovisClassics. Keep up!`,
    avatar: '/images/dealer-partner/seller-avatar3.png',
    rating: 5,
  },
  {
    name: 'Kristin Williams',
    text: `Highly recommend, was about to share my excitement about 
    the progress we've made at ClovisClassics. Keep up!`,
    avatar: '/images/dealer-partner/seller-avatar4.png',
    rating: 5,
  },
];

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const getShowcaseFeatures = async () => {
  await sleep(2000);

  return Promise.resolve({
    data: showcaseFeatures,
  });
};

export const getTestimonials = async () => {
  await sleep(2000);

  return Promise.resolve({
    data: testimonials,
  });
};
